var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stacked-bar-chart',{staticClass:"charts__chart",attrs:{"chart-data":_vm.stackedChartData,"numberOfResponses":_vm.numberOfResponses}})
}
var staticRenderFns = []

export { render, staticRenderFns }